import React, { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import InputController from '../../../Global/InputController'
import { GET_ALL_CONFIG_APP_PAGES } from '../../../../graphql/ConfigApp/configAppPages'
import {
  CREATE_OR_UPDATE_ELEMENT_BannerImageSingle,
  GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
} from '../../../../graphql/ConfigApp/configAppPageElements'

const refetchConfigsAppPage = {
  query: GET_ALL_CONFIG_APP_PAGES,
  variables: {
    limit: 10,
    offset: 0,
    searchQuery: null,
  },
}
const extensions_allowed_image = ['.png', '.jpg', '.jpeg']
const sizeMaxFile = 8 // EXPRESADO EN MB.

const BannerImageSingle = ({ pageId, dataElement, setDataElement }) => {
  //STATE
  const [file, setFile] = useState(null)

  //MUTATIONS:
  const [createOrUpdate] = useMutation(
    CREATE_OR_UPDATE_ELEMENT_BannerImageSingle
  )

  //FORM:
  const validationSchema = Yup.object().shape({
    height: Yup.string().required('Campo requerido'),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const handleCancel = () => setDataElement(null)

  const handleFile = async (e) => {
    if (!e.target.files[0]) return

    const fileName = e.target.files[0].name.toLowerCase()
    const lastDot = fileName.lastIndexOf('.')
    const extension = fileName.slice(lastDot, fileName.length)

    if (extensions_allowed_image.indexOf(extension) === -1) {
      setFile(null)
      return toastSweetAlert({
        mode: 'error',
        message: 'Solo se admite JPG, JPGE y PNG',
      })
    }

    if (e.target.files[0].size / 1048576 > sizeMaxFile) {
      setFile(null)
      return toastSweetAlert({
        mode: 'error',
        message: `El archivo no puede superar los ${sizeMaxFile}MB`,
      })
    }

    setFile(e.target.files[0])
  }

  const onSubmit = async (dataForm) => {
    try {
      let message = ''

      if (dataElement?.id) {
        //Es actualizacion
        const variables = {
          inputGeneral: {
            id: dataElement.id,
            config_app_page_id: dataElement.config_app_page_id,
            order: dataElement.order,
            layout: dataElement.layout,
          },
          inputElement: {
            height: parseInt(dataForm.height),
            link: dataForm?.link,
            urlKey: dataElement?.itemMain?.urlKey,
            file: !file ? null : file,
          },
        }
        await createOrUpdate({
          variables,
          refetchQueries: [
            {
              query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
              variables: { configAppPageId: pageId },
            },
          ],
        })
        message = 'Se actualizo correctamente'
      } else {
        if (!file) {
          return toastSweetAlert({
            mode: 'error',
            message: 'Se requiere subir imagen',
          })
        }
        //Es nuevo
        const variables = {
          inputGeneral: {
            id: null,
            config_app_page_id: dataElement.config_app_page_id,
            order: null,
            layout: dataElement.layout,
          },
          inputElement: {
            height: parseInt(dataForm.height),
            link: dataForm?.link,
            urlKey: null,
            file: file,
          },
        }
        await createOrUpdate({
          variables,
          refetchQueries: [
            { ...refetchConfigsAppPage },
            {
              query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
              variables: { configAppPageId: pageId },
            },
          ],
        })
        message = 'Se creo con exito'
      }

      setDataElement(null)

      return toastSweetAlert({ mode: 'ok', message })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  useEffect(() => {
    if (dataElement?.id) {
      const data = dataElement
      const dataFormated = {
        height: data.itemMain.height,
        link: data.itemMain.link,
      }
      reset(dataFormated)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataElement])

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            withCard={false}
            title="Elemento"
            btnSecondFunctionTitle="Cancelar"
            btnSubmitText={`${dataElement?.id ? 'Actualizar' : 'Crear'}`}
            btnSecondFunction={() => handleCancel()}
            errors={errors}
            btnSubmit={true}
            content={
              <>
                <div className="row mb-2">
                  <div className="mb-3 col-12 col-sm-4 col-md-4">
                    <InputController
                      label="Alto"
                      name="height"
                      inputType="number"
                      placeholderTxt="Escribe height"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-4 col-md-4">
                    <InputController
                      label="Link"
                      name="link"
                      type="text"
                      placeholderTxt="Escribe link"
                      control={control}
                    />
                  </div>
                </div>
                <Box
                  title="Imagen"
                  content={
                    <div
                      className="d-flex flex-wrap"
                      style={{ gap: '20px 20px' }}
                    >
                      <div className="">
                        <InputController
                          label="Imagen"
                          inputType="file"
                          formatAccept="image/*"
                          validateFormat="imageavatar"
                          validateFormatMsg="Solo se admite JPG, JPGE y PNG"
                          name="file"
                          control={control}
                          changeAction={(e) => handleFile(e)}
                        />
                      </div>
                      {dataElement?.itemMain?.url &&
                        dataElement?.itemMain?.urlKey && (
                          <div className="">
                            <label>Imagen actual</label>
                            <div>
                              <img
                                src={dataElement.itemMain.url}
                                width={'300px'}
                                alt="Logo"
                              />
                            </div>
                          </div>
                        )}
                    </div>
                  }
                />
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default BannerImageSingle
